

export const stringToSlug = (str) => {
    return str.toLocaleLowerCase().replace(/[^A-Za-z]/g, "_");
}

/**
 *  Group array of objects by single key, which doesn't need to be unique
 * @param {*} array array to group
 * @param {*} key key to group elements by
 * @param {*} bucket key to use for elements that don't have key
 * @param {*} transformer post grouping transform ala map
 * @returns an object for each unqiqe value of key in input array, whose values are an array of objects matching that key value
 */
export const simpleGroupBy = (array, key, bucket, transformer = (x) => x) => {
    return array.reduce((acc, item) => {
        let current = item?.[key] ?? bucket;
        if (current !== undefined) {
            if (!Array.isArray(acc?.[current])) {
                acc[current] = [];
            }
            acc[current].push(transformer(item));
        }
        return acc;
    }, {})
}

export default {
    stringToSlug,
    simpleGroupBy,
}